import React from "react";

// Shared page sub-tab row used across the Operations pages (Tasks, Logbook,
// Tickets, Contests, Live Action, Deployment) so they all read the same way:
// underline tabs whose active 2px bar sits on the row's 1px line (-mb-px),
// with a soft hover fill and an optional 16px icon per tab.
//
// props:
//   tabs      [{ key, label, icon? }] (icon = MUI icon component)
//   activeTab current key
//   onChange  (key) => void
//   fullWidth true  -> the underline row spans the whole container and any
//                      `rightSlot` sits on the right of that row
//             false -> the row shrinks to the tabs (inline) and rightSlot,
//                      if given, sits to the right of it without a line
//   rightSlot optional accessory node (date nav, action buttons, ...)
//   className extra classes for the outer wrapper (e.g. "mt-4")
export default function SubTabs({
  tabs,
  activeTab,
  onChange,
  fullWidth = false,
  rightSlot = null,
  className = "",
}) {
  const buttons = (
    <div className="flex gap-1">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          aria-pressed={activeTab === key}
          className={`flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 -mb-px whitespace-nowrap transition-colors ${
            activeTab === key
              ? "text-violet-800 border-violet-700"
              : "text-slate-500 border-transparent hover:text-slate-800 hover:bg-slate-50"
          }`}
        >
          {Icon && <Icon sx={{ fontSize: 16 }} />}
          {label}
        </button>
      ))}
    </div>
  );

  if (fullWidth) {
    return (
      <div
        className={`flex items-center justify-between border-b border-slate-200 ${className}`}
      >
        {buttons}
        {rightSlot && (
          <div className="flex items-center gap-1.5 pb-1.5">{rightSlot}</div>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="inline-flex border-b border-slate-200">{buttons}</div>
      {rightSlot && <div className="flex items-center gap-1.5">{rightSlot}</div>}
    </div>
  );
}
